<template>
  <div class="doc-viewer">
    <iframe
        :src="viewerUrl"
        width="100%"
        height="100%"
        frameborder="0"
    >
    </iframe>
  </div>
</template>

<style>
.doc-viewer {
  height: 100%;
}
</style>

<script>
import { officeViewerUrl } from "../../../../../../global-declare-components/helpers/officeViewer";

export default {
  props: ['url'],
  computed: {
    viewerUrl() {
      return officeViewerUrl(this.url)
    }
  }
}
</script>
